import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { queryKeys } from '../react-query.config';
import { useUser } from '@/contexts/UserContext';

// Fake delay for skeleton loading demo (remove in production)
const fakeDelay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const usePlayPickems = () => {
  const { user, isLoading } = useUser();
  const location = user?.location;

  return useQuery({
    queryKey: queryKeys.pickem.play(location),
    queryFn: async () => {
      const params = {
        selections: 'true',
        ...(location && { location }),
      };
      console.log('[usePlayPickems] 📦 API call params:', params);

      // Fake delay for demo
      await fakeDelay(1500);

      return apiClient.get('/api/pickems/play', { params });
    },
    enabled: !isLoading, // Wait for user context to be ready
  });
};

export const usePickemById = (pickemId: string) => {
  const { user, isLoading } = useUser();
  const location = user?.location;

  return useQuery({
    queryKey: queryKeys.pickem.detail(pickemId, location),
    queryFn: async () => {
      return apiClient.get('/api/pickems/{id}', {
        pathParams: { id: pickemId },
        params: location ? { location } : undefined,
      });
    },
    enabled: !!pickemId && !isLoading, // Wait for user context and ensure pickemId exists
  });
};

export const useTodayPickems = () => {
  const { user, isLoading } = useUser();
  const location = user?.location;

  return useQuery({
    queryKey: queryKeys.pickem.today(location),
    queryFn: async () => {
      return apiClient.get('/api/pickems/today', {
        params: {
          selections: 'true',
          ...(location && { location }),
        },
      });
    },
    enabled: !isLoading, // Wait for user context to be ready
  });
};

export const useRecentPickems = () => {
  const { user, isLoading } = useUser();
  const location = user?.location;

  return useQuery({
    queryKey: queryKeys.pickem.recent(location),
    queryFn: async () => {
      const params = location ? { location, limit: 100 } : { limit: 100 };

      // Fake delay for demo
      await fakeDelay(1500);

      return apiClient.get('/api/pickems/recent', {
        params,
      });
    },
    enabled: !isLoading, // Wait for user context to be ready
  });
};
